import { useEffect, useState } from "react";
import { Col, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ReactSelect, { createFilter } from "react-select";

import { personOption } from "./utils";
import { reactSelectPersonSettings } from "./reactselect";
import { useQuery } from "@tanstack/react-query";
import { personsSummaryQuery } from "../api";

export function PersonSelect({ disabled, selectedPerson, selectChange, supervised }) {
  const { t } = useTranslation();

  const [options, setOptions] = useState([]);

  const res = useQuery(personsSummaryQuery(supervised ? "supervised" : "all"));

  useEffect(() => {
    if (res.data) {
      const results = res.data.data.map(person => personOption(person, t));
      setOptions(results);
    }
  }, [res.data]);


  return <Form.Group as={Col} controlId="personId">
    <Form.Label>{disabled ? t("Person", "Henkilö") : t("PersonSelect", "Henkilövalinta")}</Form.Label>
    <ReactSelect
      name="personId"
      inputId="personId"
      menuPlacement="auto"
      options={options}
      onChange={selectChange}
      defaultValue={disabled && personOption(selectedPerson)}
      isDisabled={disabled}
      {...reactSelectPersonSettings(t)}
    />
    <Form.Control.Feedback type="invalid">{t("PersonIsMandatory", "Henkilö on pakollinen")}.</Form.Control.Feedback>
  </Form.Group>;
}
